export enum PillType {
  brand = 'brand',
  bright = 'bright',
  dark = 'dark',
  error = 'error',
  errorInverted = 'error-inverted',
  info = 'info',
  infoInverted = 'info-inverted',
  primary = 'primary',
  secondary = 'secondary',
  secondaryLight = 'secondary-light',
  neutral = 'neutral',
  neutralInverted = 'neutral-inverted',
  secondaryInverted = 'secondary-inverted',
  success = 'success',
  successInverted = 'success-inverted',
  medium = 'medium',
  mediumInverted = 'medium-inverted',
  warning = 'warning',
  warningInverted = 'warning-inverted',
  brandInverted = 'brand-inverted',
}
